import React from 'react';
import { useQuery } from '@apollo/client';
import { ApolloProvider } from 'react-apollo';
import { Provider } from 'react-intl-redux';
import { IntlProvider } from 'react-intl';
import { createGenerateClassName, jssPreset } from '@material-ui/core/styles';
import { create } from 'jss';
import { SnackbarProvider } from 'notistack';
import { withWidth } from '@material-ui/core';
import JssProvider from 'react-jss/lib/JssProvider';
import { connect } from 'react-redux';
import client from '../../lib/apolloClient';
import getMessages from '../../lib/i18n/getMessages';
import SuccessionProfileDrawerNew from '../../components/Succession/ProfileDrawer/SuccessionProfileDrawerNew';
import configureStore from '../../store/findBobPublicStore';
import { CssBaseline, MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import themes from '../../lib/themes';
import { GET_USER_PROFILE } from './SuccessionProfileDrawerQueries';
import { updateSelectedProfileDrawer } from '../../actions/profileDrawerActionCreators';
import { canViewProfile } from '../../lib/userUtils';
import SuccessionThemeProvider from '../../components/Succession/SuccessionThemeProvider';
import { CurrencyProvider } from '../../hooks/useCurrency';

// Using the new Polymet-style drawer

const SuccessionProfileDrawerContainer = (props, railsContext) => {
  let store = {};
  if (document.store) {
    store = document.store;
  } else {
    store = configureStore(props);
  }

  const theme = themes[railsContext && railsContext.theme_name];
  const generateClassName = createGenerateClassName({
    dangerouslyUseGlobalCSS: true,
    productionPrefix: 'fbSucc',
  });
  const jss = create({
    ...jssPreset(),
  });

  window.locale = (railsContext && railsContext.i18nLocale) || window.locale || 'en';
  window.currency = railsContext && railsContext.currency;

  const locale = window.locale;

  return (
    <CurrencyProvider currency={(railsContext && railsContext.currency) || 'USD'}>
      <IntlProvider locale={locale} messages={getMessages(locale)}>
        <JssProvider jss={jss} generateClassName={generateClassName} classNamePrefix="fbSucc-">
          <MuiThemeProvider theme={createMuiTheme(theme)}>
            <CssBaseline />
            <SnackbarProvider>
              <ApolloProvider client={client}>
                <Provider store={store}>
                  <SuccessionThemeProvider
                    company={props.company}
                    user={props.currentUser}
                  >
                    <SuccessionProfileDrawerWithData {...props} />
                  </SuccessionThemeProvider>
                </Provider>
              </ApolloProvider>
            </SnackbarProvider>
          </MuiThemeProvider>
        </JssProvider>
      </IntlProvider>
    </CurrencyProvider>
  );
};

const SuccessionProfileDrawerWithData = ({
  userName,
  updateSelectedProfileDrawer,
  width,
  location,
  company,
  updateBobCards,
  updateNotes,
  loadBobCardList,
  notes,
  refetch: parentRefetch,
  managedMarketplaceOnly,
  displaySocialButtons,
  disableMessageBtn,
  currentUserHasSellingTransitionGoals,
  currentUserHasLimitedAccess,
}) => {
  const { loading, error, data, refetch } = useQuery(GET_USER_PROFILE, {
    variables: { userName },
    skip: !userName,
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onCompleted: (data) => {
      if (!canViewProfile(data?.getUser)) {
        updateSelectedProfileDrawer({});
        return;
      }
    }
  });

  if (error) {
    console.error('Error fetching user profile:', error);
    return null;
  }

  return (
    <SuccessionProfileDrawerNew
      profile={{ data, loading, error }}
      updateSelectedProfileDrawer={updateSelectedProfileDrawer}
      closeSuccessionDrawer={updateSelectedProfileDrawer}
      width={width}
      location={location}
      company={company}
      updateBobCards={updateBobCards}
      updateNotes={updateNotes}
      loadBobCardList={loadBobCardList}
      notes={notes}
      refetch={refetch || parentRefetch}
      managedMarketplaceOnly={managedMarketplaceOnly}
      displaySocialButtons={displaySocialButtons}
      disableMessageBtn={disableMessageBtn}
      currentUserHasSellingTransitionGoals={currentUserHasSellingTransitionGoals}
      currentUserHasLimitedAccess={currentUserHasLimitedAccess}
    />
  );
};

const mapStateToProps = state => ({
  company: state.company,
});

export default connect(mapStateToProps, { updateSelectedProfileDrawer })(withWidth()(SuccessionProfileDrawerContainer)); 